const C = require("../constants");

const listExpensesDetail = expenses_detail => {
    return {
        type: C.EXPENSES_DETAIL_LIST,
        expenses_detail
    }
};

const expenseDetailDelete = expense_detail => {
    return {
        type: C.EXPENSES_DETAIL_DELETE,
        expense_detail
    }
};

const expenseDetailAdd = expense_detail => {
    return {
        type: C.EXPENSES_DETAIL_ADD,
        expense_detail
    }
};

export {
    listExpensesDetail,
    expenseDetailDelete,
    expenseDetailAdd
};


// WEBPACK FOOTER //
// ./src/actions/ExpenseDetailActions.js